import CertificateBuilderModel from "~/models/tracked/certificateBuilderModel";
import CertificateMapping from "./certificateMapping";
import Guid from "~/helpers/guid";
import Repo from "~/state/modules/repo";
import IRepo from "~/interfaces/repo";
import FormElement from "../../form_builder/models/formElements/formElement";
import {FormElementType} from "~/enums/formElementType";

export default class CertificateMappedFormElementContainer extends CertificateBuilderModel  {
  static repo: IRepo<CertificateMappedFormElementContainer> = new Repo<CertificateMappedFormElementContainer>('mapped_form_element_containers', CertificateMappedFormElementContainer);

  client_id: string;
  input_client_id: string;
  form_element_client_id: string;

  get rootName(): string {
    return 'mapped_form_element_containers';
  }

  constructor(mapping: CertificateMapping, json: any = {}) {
    super();
    this.defineProperty('client_id', json['client_id'] || Guid.create());
    this.defineProperty('input_client_id', json['input_client_id'] || this.input_client_id);
    this.defineProperty('form_element_client_id', json['form_element_client_id'] || this.form_element_client_id);
  }

  get formElementContainer(): FormElement {
    return FormElement.repo.findBy(fe=> fe.client_id === this.form_element_client_id)
  }

  get formElementContainerReferenceName(): string {
    return this.formElementContainer.reference_name || `Untitled ${this.formElementContainer.element_type === FormElementType.grid ? "Grid" : "Stack"}`
  }

}